<template>
  <div class="exchange-list">
    <div
      v-if="incomingExchanges.length"
      class="exchange-list-item incoming-exchange"
    >
      <h1>
        {{ $t("dashboard-files-incoming-title") }}
        <long-arrow
          width="20"
          height="22"
          fillColor="#81869E"
          direction="left"
        ></long-arrow>
      </h1>
      <div
        v-for="incomingExchange in incomingExchanges"
        :key="incomingExchange.id"
        class="exchange-files"
      >
        <exchange-list-item
          :item="incomingExchange"
          :type="`incoming`"
        ></exchange-list-item>
      </div>
    </div>
    <div
      v-if="outgoingExchanges.length"
      class="exchange-list-item outgoing-exchange"
    >
      <h1>
        {{ $t("dashboard-files-outgoing-title") }}
        <long-arrow width="20" height="22" fillColor="#81869E"></long-arrow>
      </h1>
      <div
        v-for="outgoingExchange in outgoingExchanges"
        :key="outgoingExchange.id"
        class="exchange-files"
      >
        <exchange-list-item
          :item="outgoingExchange"
          :type="`outgoing`"
          @reShareExchange="reShareExchange"
        ></exchange-list-item>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ExchangeListItem from "@/views/modules/dashboard/components/exchange/ExchangeListItem";
import LongArrow from "@/components/icons/LongArrowIcon";

export default {
  name: "ExchangeList",
  components: {
    ExchangeListItem,
    LongArrow
  },
  data() {
    return {
      exchangeCopy: ""
    };
  },
  computed: {
    ...mapState("exchange", ["incomingExchanges", "outgoingExchanges"])
  },
  methods: {
    reShareExchange(id) {
      this.$emit("reShareExchange", id);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../../../assets/styles/variables";

.exchange-list {
  padding: 20px;
}

.exchange-list-item {
  margin-bottom: 40px;
  > h1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    i {
      opacity: 0.3;
    }
  }
}

.exchange-files {
  border-top: 1px solid $middle-gray;
  border-left: 1px solid $middle-gray;
  border-right: 1px solid $middle-gray;
  &:first-of-type {
    border-top-right-radius: $radius;
    border-top-left-radius: $radius;
  }
  &:last-of-type {
    border-bottom: 1px solid $middle-gray;
    border-bottom-right-radius: $radius;
    border-bottom-left-radius: $radius;
  }
}
</style>
